import { LOGGING_START, LOGGING_POST_INFO } from '../constants/log';

export const logging = logInfo => ({
  type: LOGGING_START,
  logInfo,
});

export const logPostInfo = logInfo => ({
  type: LOGGING_POST_INFO,
  logInfo,
});
